import React, { useEffect } from 'react';
import { LegacyFrame } from '@economic/react-app';
import { useAppDrawer } from '~/app/components/AppDrawer/AppDrawerContext';

export function LegacyFrameIntegration({ path }: { path: string }) {
    const { width } = useAppDrawer();

    useEffect(() => {
        // TODO: Move to LegacyFrame implementation.
        const frame = document.querySelector('[name="firebird"]') as HTMLIFrameElement;
        frame.style.width = `calc(100% - ${width}px)`;
    }, [width]);
    return <LegacyFrame basePath={path} />;
}
